import React, { Component } from "react";
import { connect } from "react-redux";
import OrderList from "./Order/OrderList";
import {
    Grid,
    Row,
    Col,
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import DashboardSuperAdmin from "./DashboardSuperAdmin";
import { hasPermission } from 'helper/hasPermission';
import BrandDashboard from "./BrandDashboard";
import XmlReader from "./XmlReader/XmlReader";

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: JSON.parse(localStorage.getItem("user")).result.user,
        };
    }
    render() {
        return (
            <React.Fragment>
                {
                    hasPermission('super-admin-dashboard') &&
                    <div className="content">
                        <Grid fluid>
                            <Row>
                                <Col md={12}>
                                    <Card
                                        ctTableResponsive
                                        content={
                                            <div>
                                                <Grid fluid>
                                                    <Row>
                                                        {/* <XmlReader /> */}
                                                        <DashboardSuperAdmin />
                                                    </Row>
                                                </Grid>
                                            </div>
                                        } />
                                </Col>
                            </Row>
                        </Grid>
                    </div>
                }

                {
                    hasPermission('customer-dashboard') &&
                    <OrderList dashboard={true} />
                }

                {
                    hasPermission('brand-dashboard') &&
                    <BrandDashboard />
                }
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return ({
    });
};

function mapStateToProps(state) {
    return {

    };
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/Admin/Dashboard.jsx